export const salutationsMasters: string[] = ['Mr.', 'Ms.', 'M/S.', 'Mrs.'];
export const applicantStatusMasters: { [key: string]: string } = {
  // Individual: 'Individual (Resident)',
  // NRI: 'Individual (NRI)',
  Individual: 'Individual (Resident)',
  NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
  "Non-Individual": "Non-Individual"
};
export const applicantStatus: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
  NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
};

export const onboardingTypeMasters: { [key: string]: string } = {
  normal: 'Normal',
  minor: 'Minor',
};
export const nationalitiesMasters: string[] = ['Indian', 'Others'];

// 1 lakh = 0.1 million (MIL)
// 1 crore = 10 million (MIL) or 0.01 billion (BIL)
export const grossAnnualMasters = (locale: string): Array<{ key: string; value: string }> => {
  if (locale === "en-IN") {
    return [
      { key: "Below 1 lakh", value: 'BELOW 1 LAC' },
      { key: "1-5 lakhs", value: '1-5 LAC' },
      { key: "5-10 lakhs", value: '5-10 LACS' },
      { key: "10-25 lakhs", value: '10-25 LACS' },
      { key: '>25 lakhs - 1 crore', value: '>25 LACS - 1 CRORE' },
      { key: '> 1 crore', value: '> 1 CRORE' },
    ]
  } else {
    return [
      { "key": "Below 0.1 mil", "value": "BELOW 0.1 MIL" },
      { "key": "0.1-0.5 mil", "value": "0.1-0.5 MIL" },
      { "key": "0.5-1 mil", "value": "0.5-1 MIL" },
      { "key": "1-2.5 mils", "value": "1-2.5 MILS" },
      { "key": ">2.5 mils - 10 mils", "value": ">2.5 MILS - 10 MILS" },
      { "key": "> 10 mils", "value": "> 10 MILS" }
    ]
  }
}

export const PEPsMasters: string[] = ['I am PEP', 'I am Related to PEP', 'Not Applicable'];

export const addressTypesMasters: string[] = [
  'Resident/Business',
  'Resident',
  'Business',
  'Registered Office',
  'Unspecified',
];

export const genderMasters: string[] = ['Male', 'Female', 'Others'];

export const maritalMasters: string[] = ['Single', 'Married', 'Others'];

export const occupationDetailsMasters: string[] = [
  'Agriculturist',
  'Business',
  'Doctor',
  'Housewife',
  'Professional',
  'Retired',
  'Service',
  'Student',
  'Others',
];

export const uboOccupationDetailsMasters: string[] = [
  "PVT.SECTOR SERVICE",
  "PUBLIC SECTOR",
  "GOVT.SERVICE",
  "HOUSEWIFE",
  "DEFENCE",
  "PROFESSIONAL",
  "RETIRED",
  "BUSINESS",
  "AGRICULTURE",
  "STUDENT",
  "FOREX DEALER",
  "OTHERS",
]

export const IdentityProofsMasters: string[] = [
  'Photo PAN Card',
  'Passport',
  "Voter's ID",
  'Driving License',
  'Aadhar Card',
];

export const uboIdentificationTypeMasters: string[] = [
  "Passport",
  "Election ID Card",
  "PAN Card",
  "ID Card",
  "Driving License",
  "UIDIA/Aadhar Card",
  "NREGA Job Card",
  "Others",
  "Not Categorized",
  "TIN(Taxpayer Identification Number)",
  "Company Identification Number",
  "US GIIN",
  "Global Entity Identification Number",
]

export const AddressProofsMasters: string[] = [
  'Passport',
  "Voter's ID",
  'Ration Card',
  'Electricity Bill',
  'Landline/Telephone Bill',
  'Gas Bill',
  'Latest Bank Statement/Passbook',
  'Latest Depository Account Statement',
];

export const BankAccountProofsMasters: string[] = [
  'Bank Statement with IFSC printed on it',
  'Cancelled cheque leaf verified',
  'Letter from the bank giving account details',
  'Passbook (showing bank account details)',
];

export const IdProofsMasters: string[] = [
  'PAN Card',
  'Aadhar Card',
  'Driving License',
  'Passport',
];
export const idProofLabelsMasters: { [key: string]: string } = {
  'PAN Card': 'PAN Number',
  'Aadhar Card': 'Aadhar Number(Last 4 Digits)',
  'Driving License': 'Driving License Number',
  'Passport': 'Passport Number',
};

export const DrawDownMasters: number[] = [1, 2, 3, 4];

export const filterApplicationTypes = [
  { key: 'individual', value: 'Individual (Resident)' },
  // { key: 'non_individual', value: 'Non-Individual' },
  // { key: 'poa', value: 'Individual (POA)' },
  { key: 'minor', value: 'Minor' },
  { key: 'nri', value: 'Individual (NRI)' },
  { key: 'non_individual', value: 'Non-Individual' },
  // { key: 'nri_poa', value: 'Individual (NRI-POA)' },
];

export const ModeOfHoldingTypes = [
  { key: 'single', value: 'Single' },
  { key: 'either or survivor', value: 'Either Or Survivor' },
  { key: 'joint', value: 'Joint' },
];

export const DiyInvestor = [
  { key: "true", value: 'Yes' },
  { key: "false", value: 'No' },
]

export const OnboardingType = [
  { key: 'physical', value: 'Physical' },
  { key: 'digital', value: 'Digital' },
]

export const AccountType = [
  // { key: 'poa', value: 'POA' },
  { key: 'advisory', value: 'Advisory' },
  { key: 'executionary', value: 'Executionary' },
  { key: 'heldaway', value: 'Held Away' }
]

export const BseStatusMapper = [
  { key: 'disabled', value: 'Disabled' },
  { key: 'pending', value: 'Pending' },
  { key: 'active', value: 'Active' },
  { key: 'failed', value: 'Failed' },
]

export const IMAGE_UPLOAD_FORMATS = ['image/jpeg', 'application/pdf', 'image/png', 'image/jpg'];

export const INVESTOR_IMAGE_UPLOAD_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];

export const APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  sent_to_ria_signatories: 'Sent to NIAPL Signatory',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};

export const POA_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  sent_to_ria_signatories: 'Sent to NIAPL Signatory',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
  sent_to_compliance: "Sent To Compliance",
  sent_to_niapl_signatory: "Sent To NIAPL Signatory",
  sent_to_kyc_modification: "Send To KYC Modification",
};

export const ESIGN_STATUS: { [key: string]: string } = {
  NOT_GENERATED: 'notgenerated',
  PENDING_SIGNATURE: 'pendingsignature',
  SIGNED: 'signed',
  EXPIRED: 'expired',
};

export enum USER_ROLES {
  SUPER_ADMIN = 'superadmin',
  AMC_ADMIN = 'amcadmin',
  RM = 'rm',
  DISTRIBUTOR = 'distributor',
  INVESTOR = 'investor',
  FUND_MANAGER = 'fundmanager',
  TRUSTEE = 'trustee',
  WITNESS = 'witness',
  APPLICATION = 'application',
  SUBDISTRIBUTOR = 'subdistributor',
  POAAPPROVER = 'poaapprover',
  AMCAPPROVER = 'amcapprover',
  AUTHORISEDSIGNATORY = 'authorisedsignatory',
  POACHECKER = 'poa_ch',
  ANALYST = "analyst",
  ONBOARDING_SPECIALIST = "onboardingspecialist",
  OPE = "ope",
  OPM = "opm",
  IA = "ia"
}

export enum ROLE_TYPE {
  REX = 'rex',
  RSM = 'rsm',
  RTL = 'rtl',
  RWM = 'rwm',
  IA = "ia"
}

export const ApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } = {
  [USER_ROLES.POAAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_poa_approver: 'Pending',
  },
  [USER_ROLES.AMCAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_amc_approver: 'Pending',
  },
};

export const Relations = [
  'Mother',
  'Father',
  'Daughter',
  'Son',
  'Spouse',
  'Brother',
  'Sister',
  'Others',
];

export const ContactRelations: { [key: string]: string } = {
  self: 'Self',
  spouse: 'Spouse',
  dependent_children: 'Dependent Children',
  dependent_parents: 'Dependent Parents',
  depending_siblings: 'Depending Siblings',
};

export const NomineeRelations = [
  //   'MOTHER',
  //   'FATHER',
  //   'DAUGHTER',
  //   'SON',
  //   'SPOUSE',
  //   'BROTHER',
  //   'SISTER',
  //   'OTHERS',

  "FATHER",
  "MOTHER",
  "HUSBAND",
  "SPOUSE",
  "GRANDFATHER",
  "GRANDMOTHER",
  "SISTER",
  "DAUGHTER",
  "SELF",
  "BROTHER",
  "SON",
  "DAUGHTER IN LAW",
  "OTHERS"
];

export const relatedRelations = ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'OTHERS'];
export const relationshipsWithGuardian = ['MOTHER', 'FATHER', 'COURT APPOINTED LEGAL GUARDIAN']

export const adminSupportMaster: { [key: string]: string } = {
  unlock_user: 'Unlock User',
  check_whitelisted: 'Check Whitelisted',
  whitelist_user: 'Whitelist User',
  unwhitelist_user: 'Unwhitelist User',
  // change_expired_status: 'Change Expired Status',
  // change_status_to_draft: 'Change Status to draft',
};

export const IS_DOB_APPLICABLE_FOR_AMC = true;

export const REJECTED_ROLES: { [key: string]: string } = {
  poaapprover: 'POA Approver',
  amcapprover: 'Checker',
  ope: 'Compliance',
};

export const investorTypeMasters: { [key: string]: string } = {
  corporate: 'Corporate',
  trust: 'Trust',
  partnership_firm: 'Partnership Firm',
  huf: 'HUF',
  govt_bodies: 'Army/ Government Bodies',
  registered_society: 'Registered Society',
  fii_fpi: 'FII/FPI',
  bank: 'Bank',
  institutional_investor: 'Institutional Investor',
  unincorporated_or_body_of_individuals: 'Unincorporated association or a body of individuals',
  foreign_entity: 'Foreign Entity',
  company: 'Company',
  llp: 'LLP',
  sole_proprietorship: 'Sole Proprietorship'
};
export const IS_PENNYDROP_APPLICABLE_FOR_AMC = true;

export const getGroupNameMaster = ['Group-A', 'Group-B', 'Group-C'];

export const NON_INDIVIDUAL_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  sent_to_ria_signatories: 'Sent to NIAPL Signatory',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const CpUboCodesMaster: { [key: string]: string } = {
  C01: '- CP of legal person-ownership',
  C02: '- CP of legal person-other means',
  C03: '- CP of legal person-senior managing official',
  C04: '- CP of legal arrangement-trust-settlor',
  C05: '- CP of legal arrangement-trust-trustee',
  C06: '- CP of legal arrangement-trust-protector',
  C07: '- CP of legal arrangement-trust-beneficiary',
  C08: '- CP of legal arrangement-trust-other',
  C09: '- CP of legal arrangement-trust-other-settlor-equivalent',
  C10: '- CP of legal arrangement-trust-other-trustee-equivalent',
  C11: '- CP of legal arrangement-trust-other-protector-equivalent',
  C12: '- CP of legal arrangement-trust-other-beneficiary-equivalent',
  C13: '- CP of legal arrangement-trust-other-other-equivalent',
  C14: '- Unknown',
};

export const uboIdentificationTypeMaster: { [key: string]: string } = {
  "Passport": "Passport",
  "Election ID Card": "Election ID Card",
  "PAN Card": "PAN Card",
  "ID Card": "ID Card",
  "Driving License": "Driving License",
  "UIDIA/Aadhar Card": "UIDAI/Aadhar Card",
  "NREGA Job Card": "NREGA Job Card",
  "Others": "Others",
  "Not Categorized": "Not Categorized",
  "TIN(Taxpayer Identification Number)": "TIN(Taxpayer Identification Number)",
  "Company Identification Number": "Company Identification Number",
  "US GIIN": "US GIIN",
  "Global Entity Identification Number": "Global Entity Identification Number",

}
export const controllingPersonsNationalitiesMasters: string[] = ['Indian', 'Others'];

//Application types
export enum APPLICATION_TYPE {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
  MINOR = "minor",
  NRI = "nri"
}

export const AMC_APPROVER_CHECK_FOR_INDIVIDUAL = true;

export const ENABLE_EMAIL_OTP = true;

export const COMMENT_ROLES: { [key: string]: string } = {
  rm: 'RM',
  distributor: 'Distributor',
  subdistributor: 'Sub Distributor',
  amcapprover: 'Checker',
  investor: 'Investor',
  rex: 'REX',
  rsm: 'RSM',
  rtl: 'RTL',
  rwm: 'RWM',
  superadmin: "SUPER ADMIN",
  amcadmin: "AMC ADMIN",
  poaapprover: "POA APPROVER",
  authorisedsignatory: "AUTHORISED SIGNATORY",
  poa_ch: "POA CHECKER",
  analyst: "ANALYST",
  onboardingspecialist: "ONBOARDING SPECIALIST",
  ope: "OPE",
  opm: "OPM",
  ia: "IA"
};

export const APPLICATION_STATUS_AMCAPPROVER_individual: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  sent_to_ria_signatories: 'Sent to NIAPL Signatory',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
  sent_to_compliance: "Send To Compliance",
  sent_to_niapl_signatory: "Sent To NIAPL Signatory",
  sent_to_kyc_modification: "Send To KYC Modification",
};
export const IndividualApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } =
{
  [USER_ROLES.AMCAPPROVER]: {
    ...APPLICATION_STATUS_AMCAPPROVER_individual,
    sent_to_amc_approver: 'Pending',
  },
};

export const APPLICATION_LISTING_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  sent_to_ria_signatories: 'Sent to NIAPL Signatory',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  sent_to_kyc_modification: "Send To KYC Modification",
  sent_to_compliance: "Sent To Compliance",
  sent_to_niapl_signatory: "Sent To NIAPL Signatory"
};

export enum APPLICATION_TYPE_FOR_DOCUMENTS {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
  INDIVIDUAL_POA = 'individual_poa',
  NRI = 'nri',
  NRI_POA = 'nri_poa',
  NOMINEE_DOC = 'nominee',
  NOMINEE_GUARDIAN = 'nomineeGuardian',
  MINOR = 'minor',
}
export const BankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
};

export const POABankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
  // "Current POA": 'CURRENTPOA',
};

export const NRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
};

export const POANRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
  // "CURRENT POA": 'CURRENTPOA',
};
export const DistributorTypesForUserManageMent: { [key: string]: string } = {
  Individual: 'individual',
  Company: 'company',
};

export const ENABLE_KRA_DOCUMENT_FETCH = false;

export const SALT = 'F2lNZWFxUH';
export const SALT2 = 'WTVPJel6dTGVocF';

export const ONBOARDING_OPTIONS: { [key: string]: string } = {
  otp: 'Verify via OTP',
  email_consent: 'Email Consent',
};

export const ONBOARDING_VIA_OPTIONS: { [key: string]: string } = {
  physical: 'Physical',
  digital: 'Digital',
};

export const EmailConsentStatusMaster: { [key: string]: string } = {
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
  revoked: 'Revoked',
};

export const ENABLE_Email_Consent = true;

export const BloodRelations = ['Father', 'Mother', 'Son', 'Daughter', 'Spouse'];

export const BSEConsentMaster: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};

export const BseClientActivationStatusMaster: { [key: string]: string } = {
  pending: 'BSE Client Activation Pending',
  active: 'BSE Client Activated',
};

export const SUPPORT_STATUS: { [key: string]: string } = {
  sent_to_applicant1: 'Sent to applicant(s)',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_fundmanager: 'Approved by investment manager',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export const RoleTypes: { [key: string]: string } = {
  amc_rm: 'AMC',
  support_rm: 'Service',
};

export const HELDAWAY_PORTFOLIO_STATUS = "Transactions not allowed for Heldaway Portfolios."

export const currencyCodeMap: { [key: string]: string } = {
  'inr': "Rupees",
  'php': "Peso"
}

export const WEEKLYDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEB_NAME = 'NEXEDGE';
export const APP_NAME = 'Nexedge :: WMS';

export const MPOWER_ACCOUNT_TYPE_MASTER: { [key: string]: string } = {
  POA: "POA",
  EXY: "EXECUTIONARY",
  ADV: "ADVISORY",
  EXECUTIONARY: "EXECUTIONARY",
  ADVISORY: "ADVISORY",
  HLDAWY: "HELDAWAY",
  HDAW: "HELDAWAY"
}

export const ENABLE_DIY_INVESTOR_ONBOARDING = false
export const ENABLE_ORDER_MANAGEMENT = true
export const ENABLE_PAYMENT_CHECKER = true
export const PHYSICAL_DIGITAL_FLOW = true // NEEDS TO BE FALSE IN PROD TILL API IS DEPLOYED
export const ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD = true

export const PAYMENT_LOOPBACK_URL = "https://nexedgewms.kfintech.com/bsetrade"

export const ORDER_ENTRY_SETTLEMENT_METHOD_CODE: { [key: string]: string } = {
  "Online Transfer": "0",
  "Client Offline Transfer": "1",
  "Initiate Transfer": "2",
};

export const requestReportsMaster = (filterType: string): { [key: string]: string } => ({
  // 1: "Title",
  3: "Executive Summary",
  4: filterType === "customer" ? "Client Portfolio Overview" : "Family Portfolio Overview",
  5: "Portfolio Summary",
  // 6: "Portfolio Cashflow Summary",
  // 7: "Portfolio Highlights: Monthly Update",
  8: "Holding Reports",
  16: "Transaction Reports",
  // 21: "Portfolio Attributes- Equity",
  // 22: "Portfolio Attributes- Fixed Income",
  23: "Concentration Analysis: Asset Manager wise",
  24: "Concentration Analysis: Instrument wise",
  // 25: "Portfolio Liquidity Analysis",
  // 26: "IPS Frameworks/ Guidelines",
  // 27: "Top 10 Equity Mutual Fund Holding Overlap",
  // 28: "Annexure1",
  // 29: "Annexure2"
})

export const REPORTS_FILTER_TYPE_OPTIONS: Array<{ key: string; value: string; }> = [
  { key: "FAMILY", value: "FAMILY" },
  { key: "CLIENT", value: "CUSTOMER" },
  { key: "PORTFOLIO", value: "PORTFOLIO" }
]

export const BSE_PAYMENT_FLOW = true
export const ONBOARDING_KYC_VERIFIED_MESSAGE = true
export const ONBOARDING_DOWNLOAD_APPLICATIONS_IGNORE_STATUS_CHECK = true
export const DOCUMENT_UPLOAD_DOWNLOAD_APPLICATION = true
export const ONBOARDING_DEMAT_DETAILS = false
export const NEXEDGE_INVESTMENT_PREFERENCE = true
export const NEXEDGE_MDMS_APIS = true

export const MAX_SCHEMES_SELECTED = 20

export const MAX_REQUIRED_AUTHORISED_SIGNATORIES: number[] = [1, 2, 3, 4, 5]

export const CONTENT_TYPE = {
  PDF: "application/pdf",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  OCTET_STREAM: "application/octet-stream"
}

export const FAMILY_MAPPING_TYPE = {
  NEW: "new",
  EXISTING: "existing"
}

export const INDIVIDUAL_ONBOARDING_CHAR_LIMIT = {
  PERSONAL_DETAILS: {
    FIRST_NAME: 70,
    LAST_NAME: 70,
    FULL_NAME: 70
  }
}

export const MINOR_ONBOARDING_CHAR_LIMIT = {
  PERSONAL_DETAILS: {
    GUARDIAN_FIRST_NAME: 120,
    GUARDIAN_LAST_NAME: 120,
    GUARDIAN_FULL_NAME: 120,
    MINOR_FIRST_NAME: 70,
    MINOR_LAST_NAME: 70
  }
}

export const NON_INDIVIDUAL_ONBOARDING_CHAR_LIMIT = {
  CONTRIBUTOR_DETAILS: {
    NAME_OF_ENTITY: 70
  }
}

export const NOMINEE_OPT_OUT_DISCLAIMER = "I / We hereby confirm that I / We do not wish to appoint any nominee(s) for my mutual fund units held in my / our mutual fund folio and understand the issues involved in non-appointment of nominee(s) and further are aware that in case of death of all the account holder(s), my / our legal heirs would need to submit all the requisite documents issued by Court or other such competent authority, based on the value of assets held in the mutual fund folio."

export const REPORTS_DOWNLOAD_OPTION = [
  { key: 'PDF', value: 'pdf' },
  { key: 'Excel', value: 'excel' },
]

export const NOMINEE_OPT_OUT_FEATURE_ENABLED = false

export const SWP_FIRST_ORDER_FLAG_LABEL = "Withdraw 1st Installment Today"

export const STP_FIRST_ORDER_FLAG_LABEL = "Transfer 1st Installment Today"

export const BANK_SUB_ACCOUNT_TYPES: Record<string, string> = {
  REG: "Regular",
  POA: "POA",
  PISNRE: "PISNRE",
  PISNRO: "PISNRO",
}

export const UTILIZED_BALANCE_DESCRIPTION = "Total value of all transactions that have been initiated and are currently in transit (pending, completion/approval), thereby reserving those funds from the available bank balance until the transaction process is completed"

export const AVAILABLE_BANK_BALANCE_DESCRIPTION = "Current available bank balance in selected account"

export const NET_AVAILABLE_BALANCE_DESCRIPTION = "Actual balance available for new transactions after deducting the Utilized Balance from the Available Bank Balance"

export const REFERENCE_NUMBER_DESCRIPTION = "Reference number of the payment/transaction made outside the platform"

export const INITIATE_TRANSFER_DESCRIPTION = "Use this option to place the order and initiate the payment through the platform"

export const CLIENT_OFFLINE_TRANSFER_DESCRIPTION = "Payment has already been made outside the platform. No payment will be initiated through the system"

export const RIA_FEE_DECLARATION_POINTS = [
  {
    id: "1",
    text: "I/We do not have any investment in Securities or any similar investment products under distribution mode with Nexedge Group.",
  },
  {
    id: "2",
    text: "I/We have availed distribution service/financial Products from Nexedge Group.",
    subPoints: [
      {
        id: "2.1",
        text: "I/We shall continue to hold the existing investments till such time I/we decide to redeem or take any other permitted action. I/We understand and authorize the Nexedge Group to not execute any further investment transaction in the distribution mode, and cease/stop/re-register under RIA Systematic Investment Plan (SIP)/Systematic Transfer Plan (STP) transactions for which the instructions have been provided by me/us prior to the date of signing up for Advisory Service as the case may be. I/We understand that SIP/STP will stop in on-line/ execution mode.",
      },
      {
        id: "2.2",
        text: "I/We wish to liquidate / switch my/our investments to Investment Advisory Services and I/we will provide the requisite instructions for the same separately. I/We understand the tax implications and exit load, if any, that will be applicable on liquidation / switch and the same will be borne by me / us.",
      },
    ],
  },
];

export const UNLISTED_EQUITY_ORDER_DATE_MIN_RANGE = 5

export const PRICE_TYPE_DROPDOWN_LIST = [
  {
    key: "Clean Price",
    value: "cleanPrice"
  },
  {
    key: "Dirty Price",
    value: "dirtyPrice"
  }
]

export const applicantStatusValueMap: Record<string, string> = {
  individual: "individual",
  nri: "nri",
  nonindividual: "nonindividual"
}

export const EXPORT_TOOLTIP_TEXT = "The exported file will reflect the data as filtered by your current search and filter selections. If no filters are applied, the full data set will be exported."
